import AddUserPage from "../../component/users/dynamic-users/AddUser"

 
function AddUser() {
  return (
    <div className="page-body"><AddUserPage/></div>
  )
}

export default AddUser